import {submitChatMessages} from "../actions/submitChatMessages";
import {loadMappedModal} from "../actions/displayModal";

export function giftPicker() {
    $(document).ready(function () {
        function showModalById(modalId) {
            const modalElement = document.getElementById(modalId);
            const selector = `[data-bs-toggle="modal"][data-bs-target="#${modalId}"]`;
            const existingTrigger = document.querySelector(selector);

            if (existingTrigger) {
                existingTrigger.dispatchEvent(new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window,
                }));

                return true;
            }

            const temporaryTrigger = document.createElement('button');
            temporaryTrigger.type = 'button';
            temporaryTrigger.style.display = 'none';
            temporaryTrigger.setAttribute('data-bs-toggle', 'modal');
            temporaryTrigger.setAttribute('data-bs-target', `#${modalId}`);
            document.body.appendChild(temporaryTrigger);
            temporaryTrigger.dispatchEvent(new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            }));
            document.body.removeChild(temporaryTrigger);

            if (!modalElement) return true;
            window.growtypeModal?.show(modalElement);
            return true;
        }

        const pickerWrapper = $('.g-chatform-giftpicker-content');

        if (pickerWrapper.length === 0) {
            return
        }

        let chatForm = pickerWrapper.closest('.g-chatform');
        let chatId = chatForm.attr('id');

        const gifts = window.growtype_chat[chatId]['gifts'];
        const categories = [...new Set(gifts.map(g => g.category))];
        let pickerInitialized = false;

        function renderGifts(gifts, container) {
            container.empty();
            gifts.forEach(gift => {
                const isLocked = gift.premium && !$('body').hasClass('active-subscription');
                let content = gift.svg ? gift.svg : `<div class="emoji-icon">${gift.icon}</div>`;

                if (gift.image) {
                    content = `<img src="${gift.image}" alt="${gift.title || ''}" class="gift-image" loading="lazy" decoding="async" />`;
                }

                content = `<div class="content">${content}</div>`;

                const title = gift.title ? `<div class="title">${gift.title}</div>` : '';
                const credits = gift.credits ? `<div class="credits"><svg enable-background="new 0 0 53 53" height="512" viewBox="0 0 53 53" width="512" xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" data-sentry-element="svg" data-sentry-source-file="tokens-icon.jsx" data-sentry-component="TokensIcon"><g id="_x31_16" data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><g data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><path d="m50.5044823 26.5043678c0 13.2560272-10.7485657 23.9952545-24.0044823 23.9952545s-24.0044811-10.7392272-24.0044811-23.9952545c0-13.2558021 10.7485655-24.0043678 24.0044811-24.0043678s24.0044823 10.7485657 24.0044823 24.0043678z" fill="#f9b938" data-sentry-element="path" data-sentry-source-file="tokens-icon.jsx"></path></g><g data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><path d="m50.5015945 26.5011883c0 13.2549648-10.74374 23.9988117-23.9987087 23.9988117-7.1624584 0-13.5915308-3.1326332-17.9839401-8.1118965 4.2283916 3.7280197 9.7772341 5.98032 15.8524675 5.98032 13.2549667 0 23.9987068-10.7438469 23.9987068-23.9987087 0-6.0752316-2.2608299-11.6239691-6.0061302-15.8612108 4.9879046 4.3752383 8.1376047 10.8128442 8.1376047 17.9926843z" fill="#e5a320" data-sentry-element="path" data-sentry-source-file="tokens-icon.jsx"></path></g><g opacity=".3" data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><g data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><path d="m7.6255941 18.197897c-.3193946-.1618042-.4466467-.5511456-.2848425-.8696957 2.1776114-4.2970753 5.7608948-7.8247385 10.0899925-9.9324036.3219223-.158433.7095776-.0219111.8646412.298326.1567459.3210797.0235958.708735-.2983265.8646398-4.0762796 1.9854689-7.4505663 5.3075066-9.5017691 9.35429-.1604041.3172455-.548582.446846-.8696956.2848435z" fill="#fff" data-sentry-element="path" data-sentry-source-file="tokens-icon.jsx"></path></g></g><g opacity=".3" data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><g data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><path d="m21.5146084 6.5446415c-.0825863-.3480473.133152-.6969371.4803562-.7786818 1.1242008-.2654595 2.2821102-.444118 3.4417038-.5309191.3556328-.012641.6674423.2410207.6935673.5974946.026125.3564744-.2410202.6665988-.597496.6935663-1.0921764.0817447-2.1818237.2494473-3.2394485.4988952-.355755.0830098-.6982785-.1383972-.7786828-.4803552z" fill="#fff" data-sentry-element="path" data-sentry-source-file="tokens-icon.jsx"></path></g></g><g data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><path d="m44.2318916 26.5065022c0 2.916647-.7050514 5.6651478-1.9631462 8.093111-2.9408073 5.7132721-8.9025269 9.6316414-15.7695293 9.6316414-6.8591747 0-12.8288202-3.9183693-15.7697248-9.6316414-1.2579002-2.4279633-1.9631462-5.1764641-1.9631462-8.093111 0-9.7838421 7.9569521-17.7407951 17.732872-17.7407951 9.7838411.0000009 17.7326745 7.956953 17.7326745 17.7407951z" fill="#f7f363" data-sentry-element="path" data-sentry-source-file="tokens-icon.jsx"></path></g><g data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><path d="m39.9849625 15.0077686c-3.092907-2.6522522-7.0994072-4.2468309-11.4905167-4.2468309-9.775919 0-17.732872 7.9569521-17.732872 17.7407951 0 2.9166451.705246 5.6651459 1.9632435 8.0931091.6169186 1.2099724 1.3701916 2.33181 2.2435818 3.3574982-1.738759-1.4905052-3.181138-3.3094711-4.2389088-5.352726-1.2579002-2.4279633-1.9631462-5.1764641-1.9631462-8.093111 0-9.7838421 7.9569521-17.7407951 17.732872-17.7407951 5.4007549 0 10.2405414 2.427865 13.4857464 6.2420606z" fill="#edd318" data-sentry-element="path" data-sentry-source-file="tokens-icon.jsx"></path></g><g data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><g data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><path d="m28.5267735 17.8254948 1.9659557 3.9834614 4.3960114.6387787c1.854641.269495 2.595192 2.5486717 1.2531586 3.8568268l-3.1809845 3.1006927.7509308 4.3782501c.3168106 1.8471451-1.6219749 3.2557564-3.2808151 2.3836517l-3.9319115-2.067131-3.9319115 2.067131c-1.6588421.8721046-3.5976257-.5365067-3.2808151-2.3836517l.7509289-4.3782501-3.1809845-3.1006927c-1.3420305-1.3081551-.6014805-3.5873318 1.2531605-3.8568268l4.3960114-.6387787 1.9659557-3.9834614c.8294199-1.6805897 3.2258891-1.6805897 4.0553092 0z" fill="#f9b938" data-sentry-element="path" data-sentry-source-file="tokens-icon.jsx"></path></g><g opacity=".4" data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><g data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><path d="m26.9962139 20.3735962c.0233459.3148899-.2215748.5947609-.5364647.6181068-.0932426.011673-.2099037.0350189-.3148193.1282616-.0583649.0466919-.0933132.1049156-.128334.1632824l-1.1778469 2.3907127c-.2448502.5013752-.7230225.851284-1.2827625.9328537l-2.6355649.3847866c-.2099037.0233459-.3731842.1634235-.4314785.3615818-.0699673.1981602-.011673.3966026.1282616.548069.3352776.3270149 1.995491 1.9463215 1.8891964 1.8426456.2332497.2215042.2332497.5947609.011673.8279381-.2194729.2194729-.5724144.2416134-.8279381.011673l-1.7959538-1.7726078c-.0232754-.011673-.0582943-.0350189-.0816402-.0700378-.4780998-.4546833-.6413822-1.131155-.4314785-1.7492619.1982994-.6179638.7230225-1.0727882 1.3760757-1.1661739l2.6238918-.3731136c.1749554-.0233459.3265629-.1399345.408205-.303215l1.1778469-2.3788986c.0816402-.1750984.1982288-.3148899.3264923-.4432945.0233459-.0348778.0466919-.0582237.0816402-.0932426.2798691-.2331791.6181068-.3731136 1.0028915-.3964596.3032171-.035019.5947611.2098311.618107.536394z" fill="#fff" data-sentry-element="path" data-sentry-source-file="tokens-icon.jsx"></path></g></g><g data-sentry-element="g" data-sentry-source-file="tokens-icon.jsx"><path d="m36.1389809 26.3095245-3.1836357 3.0902481c.0775108.4483471-.2807808-1.6241589.7580452 4.3848267.3133087 1.8446007-1.6229782 3.2488327-3.2789745 2.3779755-2.1435089-1.1272354-4.0477962-2.1201515-3.9396477-2.0630875l-3.9300022 2.0641518c-1.6560173.87463-3.591835-.5363922-3.2769451-2.3790398l.1049156-.6414528c.4431515 1.2011948 1.8891964 1.8776665 3.1720295 1.2128677l3.3103275-1.7485123c.3798656-.2006454.840435-.1697769 1.1901245.0797691l1.9010296 1.3566055c1.0288906.73423 2.5531158.0933304 2.6008072-1.1697769.0028896-.0765305-.0004368-.1467857-.0111313-.2089806l-.6461582-3.7863617c-.0627136-.367485.0589199-.7423477.325449-1.0030022l2.7463722-2.685854c.8280106-.8047352.862957-1.982439.3381653-2.8221931l.5714836.0817127c1.8541793.2681963 2.5888748 2.5421793 1.2477455 3.8601038z" fill="#e5a320" data-sentry-element="path" data-sentry-source-file="tokens-icon.jsx"></path></g></g></g></svg> ${gift.credits}</div>` : '';
                const giftHTML = $(`
                    <div class="gift-item ${gift.premium ? 'premium' : ''} ${isLocked ? 'locked' : ''}"
                         data-gift-id="${gift.id ?? ''}"
                         data-category="${gift.category}"
                         data-message="${gift.message || ''}"
                         title="${gift.title || ''}">
                        ${credits}
                        ${content}
                        ${title}
                    </div>
                `);
                container.append(giftHTML);
            });
        }

        function initializePicker() {
            if (pickerInitialized) {
                return;
            }

            pickerInitialized = true;
            pickerWrapper.html(`
                <div class="giftpicker-category">
                    <select class="giftpicker-category-select">
                        <option value="all">All Categories</option>
                        ${categories.map(c => `<option value="${c}">${c.charAt(0).toUpperCase() + c.slice(1)}</option>`).join('')}
                    </select>
                </div>
                <div class="giftpicker-tabs">
                    <button class="tab-btn active" data-tab="free">Free</button>
                    <button class="tab-btn" data-tab="premium">Premium</button>
                </div>
                <div class="giftpicker-tab-content active" data-tab-content="free"></div>
                <div class="giftpicker-tab-content" data-tab-content="premium"></div>
            `);

            const freeTab = pickerWrapper.find('[data-tab-content="free"]');
            const premiumTab = pickerWrapper.find('[data-tab-content="premium"]');

            function filterAndRender(category) {
                const filtered = category === 'all'
                    ? gifts
                    : gifts.filter(g => g.category === category);

                renderGifts(filtered.filter(g => !g.premium), freeTab);
                renderGifts(filtered.filter(g => g.premium), premiumTab);
            }

            filterAndRender('all');

            pickerWrapper.on('change', '.giftpicker-category-select', function () {
                filterAndRender($(this).val());
            });
        }

        // Tab switch
        pickerWrapper.on('click', '.tab-btn', function () {
            const tab = $(this).data('tab');
            pickerWrapper.find('.tab-btn').removeClass('active');
            $(this).addClass('active');
            pickerWrapper.find('.giftpicker-tab-content').removeClass('active');
            pickerWrapper.find(`[data-tab-content="${tab}"]`).addClass('active');
        });

        // Gift click
        pickerWrapper.on('click', '.gift-item', function () {
            if ($(this).hasClass('locked')) {
                pickerWrapper.fadeOut();
                $('.g-chatform-giftpicker').removeClass('is-active');
                loadMappedModal('growtypeChatStarterPackModal');
                return;
            }

            const giftId = $(this).data('gift-id') && $(this).data('gift-id').length > 0 ? $(this).data('gift-id') : $(this).attr('title').toLowerCase()
            const message = $(this).data('message');
            const content = '<div class="gift-wrapper">' + $(this).find('.content').html() + '</div>';
            const input = $(this).closest('.g-chatform').find('.g-chatform-text-input');
            const userToken = chatForm.attr('data-user-token');

            pickerWrapper.fadeOut();

            $('.g-chatform-giftpicker').removeClass('is-active');

            submitChatMessages([
                {
                    'value': content,
                    'gift_id': giftId,
                }
            ], chatForm);
        });

        // Toggle
        $('.g-chatform-giftpicker-trigger').click(function () {
            initializePicker();
            pickerWrapper.fadeToggle();
            $(this).closest('.g-chatform-giftpicker').toggleClass('is-active');
        });

        $('body').click(function (e) {
            if (!$(e.target).closest('.g-chatform-giftpicker').length) {
                pickerWrapper.fadeOut();
                $('.g-chatform-giftpicker').removeClass('is-active');
            }
        });
    });
}
